/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

const designs = {
  '': '/designs',
  'learner-home': '/designs/learner-home',
  'program-of-study': '/designs/program-of-study',
  'hs-program-of-study': '/designs/hs-program-of-study',
  'ms-exploration': '/designs/ms-exploration',
  'ms-exploration-hawaiian': '/designs/ms-exploration-hawaiian',
  'lmi-internship': '/designs/lmi-internship',
  'adult-reentry': '/designs/adult-reentry',
  'parent-view': '/designs/parent-view',
  'educator-view': '/designs/educator-view',
  uhcc: '/designs/uhcc',
};

export default designs;
